<div class="ngx-dialog goreact-modal default-ai-markers-dialog-container" cdkTrapFocus>
	<div class="goreact-modal-header">
		<span class="header-label">
				<h4 class="modal-title">{{'default-ai-marker-title' | translate}}</h4>
		</span>
		<button type="button" class="close-btn" (click)="cancel()" attr.aria-label="{{ 'common_close' | translate }}">
			<i class="ficon-app-x"></i>
		</button>
	</div>

	<div class="goreact-modal-body">
		<div>{{ 'default-ai-marker-dialog-sub-title' | translate }}</div>
		<div class="markers-container" *ngIf="(loading$ | async) === false">
			<div *ngIf="(allLlmDefinitions$ | async) as allPrompts">
				<div class="use-types-container">
					<mat-form-field goSelect>
						<mat-label>{{ 'default-ai-marker-dialog-use_type' | translate }}</mat-label>
						<mat-select
							disableOptionCentering
							panelClass="offsetPanel"
							(selectionChange)="filterUseType($event.value)"
							[value]="selectedUseType">
							<mat-option
								*ngFor="let type of useTypes"
								[value]="type">
								{{ type.name }}
							</mat-option>
						</mat-select>
						<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
					</mat-form-field>
					<span class="marker-count" *ngIf="allPrompts.length > 0"> ({{ allPrompts.length }}) </span>
				</div>

				<div class="markers">
					<div class="marker-item" *ngFor="let prompt of allPrompts">
						<marker [marker]="prompt.tags[0]" [aiStyle]="true" [withName]="true"></marker>
						<div class="prompt-description">{{ prompt.description }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="goreact-modal-footer">
		<button class="tertiary-btn cancel-btn goreact-btn" (click)="cancel()" translate="common_cancel"></button>
		<button class="primary-btn save-btn goreact-btn" (click)="save()">{{ (mode === 'add' ? 'common_add' : 'common_save') | translate }}</button>
	</div>
</div>
